var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper},[_c('img',{attrs:{"src":_vm.icon,"alt":_vm.title}}),_c('div',{class:_vm.$style.info},[_c('span',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.title))]),_c('span',{class:_vm.$style.content},[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }